import { boldAutoColumn } from "../../../../../utils/pdf/page";

export const buildIrasCrossYAHeaders = ({
  company,
  currencyView = "SGD",
  forView,
  hasSgdColumn = false,
}) => {
  const yaColSpan = hasSgdColumn ? 3 : 2;
  const yearOfAssessment = Number(company?.yearOfAssessment);
  const precedingYA = Number.isFinite(yearOfAssessment)
    ? yearOfAssessment - 1
    : "";
  const currentYA = Number.isFinite(yearOfAssessment)
    ? yearOfAssessment
    : company?.yearOfAssessment || "";
  const currencyHeaders = [
    "",
    boldAutoColumn(currencyView),
    boldAutoColumn(currencyView),
    ...(hasSgdColumn ? [boldAutoColumn("SGD")] : []),
    boldAutoColumn(currencyView),
    boldAutoColumn(currencyView),
    ...(hasSgdColumn ? [boldAutoColumn("SGD")] : []),
    boldAutoColumn("Sch"),
  ];

  if (forView) {
    currencyHeaders.push({
      content: "Reference",
      styles: { textColor: [255, 0, 0], fontStyle: "bold" },
    });
  }

  return [
    [
      "",
      {
        content: `Preceding YA ${precedingYA}`.trim(),
        colSpan: yaColSpan,
        styles: { fontStyle: "bold" },
      },
      {
        content: `Current YA ${currentYA}`.trim(),
        colSpan: yaColSpan,
        styles: { fontStyle: "bold" },
      },
      "",
      ...(forView ? [""] : []),
    ],
    currencyHeaders,
  ];
};

export const getIrasCrossYAMainCompColumnStyles = (
  hasSgdColumn,
  hasReferenceColumn = false,
) => {
  if (hasSgdColumn) {
    return {
      0: { halign: "left", minCellWidth: hasReferenceColumn ? 70 : 82 },
      1: { halign: "right", valign: "bottom", cellWidth: 23 },
      2: { halign: "right", valign: "bottom", cellWidth: 23 },
      3: { halign: "right", valign: "bottom", cellWidth: 23 },
      4: { halign: "right", valign: "bottom", cellWidth: 23 },
      5: { halign: "right", valign: "bottom", cellWidth: 23 },
      6: { halign: "right", valign: "bottom", cellWidth: 23 },
      7: { halign: "center", cellWidth: 17 },
      ...(hasReferenceColumn
        ? { 8: { halign: "center", cellWidth: 34 } }
        : {}),
    };
  }

  return {
    0: { halign: "left", minCellWidth: hasReferenceColumn ? 80 : 94 },
    1: { halign: "right", valign: "bottom", cellWidth: 30 },
    2: { halign: "right", valign: "bottom", cellWidth: 30 },
    3: { halign: "right", valign: "bottom", cellWidth: 30 },
    4: { halign: "right", valign: "bottom", cellWidth: 30 },
    5: { halign: "center", cellWidth: 19 },
    ...(hasReferenceColumn
      ? { 6: { halign: "center", cellWidth: 38 } }
      : {}),
  };
};
